import { useMutation } from "@tanstack/react-query"

import { apiFetchBlob } from "@/lib/api/client"
import type { Evidence, ApiEvidence } from "@/types/evidence"

export function toEvidence(data: ApiEvidence): Evidence {
  return {
    id: data.id,
    filename: data.filename,
    contentType: data.content_type,
    byteSize: data.byte_size,
    sha256: data.sha256,
    uploadedById: data.uploaded_by_id,
    uploadedAt: data.uploaded_at,
  }
}

/**
 * Fetches a file through the API, from the organisation's Origin a plain link
 * would not send, and hands back a local URL to show it. The caller revokes it.
 */
export function useViewEvidence() {
  return useMutation({
    mutationFn: async (evidenceId: string) =>
      URL.createObjectURL(
        await apiFetchBlob(`/evidence/${evidenceId}/download`)
      ),
  })
}
